import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledBanner } from "./styles";
import { StyledBannerText } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";

type Props = {
    isVisible: boolean;
};

const SignalValidationBanner = (props: Props) => {
    return (
        <StyledBanner
            isVisible={props.isVisible}
            notificationType="warning"
        >
            <I18n
                element={StyledBannerText}
                translatable={{ key: "si.signals.banner.duplicate-signal.text" }}
            />
        </StyledBanner>
    );
};

export default SignalValidationBanner;
